import React from 'react';
import { Calendar, RotateCcw } from 'lucide-react';
import CustomDatePicker from '../../common/CustomDatePicker';

/**
 * 시작일과 종료일을 선택하고 초기화할 수 있는 기간 필터 컴포넌트.
 */
const DateRangeFilter = ({ startDate, setStartDate, endDate, setEndDate, clearDateFilter }) => {
    return (
        <div className="flex items-center gap-2 bg-white border border-gray-200 rounded-2xl px-3 sm:px-4 h-11 shadow-sm w-full md:w-auto overflow-visible min-w-0 transition-all hover:border-blue-200 hover:shadow-md group/date">
            <div className="flex-1 flex items-center gap-2 min-w-0">
                <Calendar size={14} className="text-gray-400 flex-shrink-0 group-hover/date:text-blue-500 transition-colors" />
                <div className="flex-1 flex items-center justify-around gap-2 px-1">
                    <CustomDatePicker
                        value={startDate ?? ''}
                        onChange={(v) => setStartDate?.(v)}
                        placeholder="연도-월-일"
                        align="-left-10 md:-left-14"
                    />
                    <span className="text-gray-200 text-[10px] scale-125 sm:scale-150 flex-shrink-0">~</span>
                    <CustomDatePicker
                        value={endDate ?? ''}
                        onChange={(v) => setEndDate?.(v)}
                        placeholder="연도-월-일"
                        align="-left-20 md:-left-26"
                    />
                </div>
            </div>
            <button
                onClick={() => clearDateFilter?.()}
                className="p-1.5 hover:bg-gray-100 rounded-full text-gray-300 transition hover:text-blue-500 flex-shrink-0"
            >
                <RotateCcw size={14} />
            </button>
        </div>
    );
};

export default DateRangeFilter;
